import React from 'react';
import { Link } from 'react-router-dom';

import { Button, buttonVariants } from '@/design-system/button';
import { APP_CONFIG } from '@/config/app';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-weak-50 px-6">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <p className="label-eyebrow mb-4">
            <span className="text-accent font-bold mr-3">404</span>
            Page not found
          </p>
          <h1 className="text-5xl font-extrabold tracking-tight text-text-strong-950 mb-3 tabular">
            Off the grid.
          </h1>
          <p className="text-sm text-text-sub-600 leading-relaxed border-t border-stroke-soft-200 pt-4 mt-4">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="flex items-center justify-center gap-3">
          <Link to={APP_CONFIG.homeRoute} className={buttonVariants()}>
            <i className="ri-home-line text-[16px] mr-2"></i>
            Go to home
          </Link>

          <Button
            tone="neutral"
            style="stroke"
            onClick={() => window.history.back()}
          >
            <i className="ri-arrow-left-line text-[16px] mr-2"></i>
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
